import Select from 'react-select'
import RadioInput from './RadioInput'
import InstallationFactoryDistanceItem from './InstallationFactoryDistanceItem'
import { FormikProps } from 'formik'
import { InitialState as SurveyInitialState } from 'Store/Survey'
import clsx from 'clsx'
import { KTSVG } from '_metronic/helpers'
import { useRef } from 'react'
import Swal from 'sweetalert2'

interface Props {
  isView?: boolean
  lockShippingOnly?: boolean
  formik: FormikProps<SurveyInitialState>
  onCheckInstallationCategory: (key: string, val: any) => void
  onChangeInstallationCategory: (key: string, val: any) => void
  onChangeFactoryDistance: (name: string, key: string, value: any) => void
}

const MOCK_TYPE_OPTIONS = [
  {
    label: 'Pure Drive',
    value: 'PURE_DRIVE',
  },
  {
    label: 'Prebore+Drive',
    value: 'PREBORE_DRIVE',
  },
  {
    label: 'Auger+Drive',
    value: 'CENTER_AUGER_FINAL_DRIVE',
  },
  {
    label: 'FC - PIG',
    value: 'FC_PIG',
  },
  {
    label: 'Jack In Pilling',
    value: 'JIP',
  },
  {
    label: 'Green Pile',
    value: 'GREEN_PILE',
  },
  {
    label: 'Precast Product',
    value: 'PRECAST_PRODUCT',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
]

const MOCK_INSTALLATION_CATEGORY_CHILD__OPTIONS = [
  {
    label: 'Hydraulic',
    value: 'HYDRAULIC',
  },
  {
    label: 'Rig (ปั้นจั่น) โครง ',
    value: 'RIG_DAVIT_STRUCTURE',
  },
  {
    label: 'Rig (ปั้นจั่น) แทรค ',
    value: 'RIG_DAVIT_TAG',
  },
  {
    label: 'Rig (ปั้นจั่น) ล้อยาง ',
    value: 'RIG_DAVIT_WHEEL',
  },
]

const MOCK_TRANSPORTATION_OPTIONS = [
  {
    label: 'รถเฮี๊ยบ',
    value: 'TRUCK_LOADER_CRANE',
  },
  {
    label: 'สาลี่',
    value: 'SALI',
  },
  {
    label: 'รถหกล้อ',
    value: 'TRUCK',
  },
  {
    label: 'รถสิบล้อ',
    value: 'TRUCK_10_WHEEL',
  },
  {
    label: 'แบบตอปิโด',
    value: 'TOWING',
  },
  {
    label: 'เทรลเลอร์',
    value: 'TRAILER',
  },
]

const MOCK_TRANSPORTATION_TIME_OPTIONS = [
  {
    label: 'ได้ทั้งกลางวันและกลางคืน',
    value: 'DAY_AND_NIGHT',
  },
  {
    label: 'ได้เฉพาะกลางวัน',
    value: 'DAY_ONLY',
  },
  {
    label: 'ได้เฉพาะกลางคืน',
    value: 'NIGHT_ONLY',
  },
]

const RISK_OF_DRILLING_OPTIONS = [
  {
    label: 'มีความเสี่ยง',
    value: 'มีความเสี่ยง',
  },
  {
    label: 'ไม่มีความเสี่ยง',
    value: 'ไม่มีความเสี่ยง',
  },
]

const Installation: React.FC<Props> = ({
  isView,
  lockShippingOnly = false,
  formik,
  onCheckInstallationCategory,
  onChangeInstallationCategory,
  onChangeFactoryDistance,
}) => {
  const adjacentPictureNorthRef = useRef<any>(null)
  const adjacentPictureSouthRef = useRef<any>(null)
  const adjacentPictureEastRef = useRef<any>(null)
  const adjacentPictureWestRef = useRef<any>(null)

  const checkingFileAllowedTypesAdjacentPicture = (file: any) => {
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg']
    if (file) {
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          text: 'สามารถอัพโหลดได้เฉพาะไฟล์ประเภท .PNG, .JPEG หรือ .JPG',
          confirmButtonText: 'ปิด',
        })
        return false
      }
    }
    return true
  }

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title fw-bold'>ส่วนที่ 1 - การติดตั้ง</div>
      </div>

      <div className='card-body'>
        <div className='row gx-3 gy-8'>
          <div className='col-12 col-xl-8'>
            <label htmlFor='shippingOnly' className='fs-6 mb-3 fw-bold'>
              จัดส่งอย่างเดียว
            </label>

            <div className='form-check form-check-custom'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={lockShippingOnly ? true : formik.values.shippingOnly}
                onChange={(e: any) => {
                  if (lockShippingOnly) return
                  formik.setFieldValue('shippingOnly', e.currentTarget.checked)
                }}
                id='shippingOnly'
                disabled={isView || lockShippingOnly}
              />
              <label className='form-check-label text-black' htmlFor='shippingOnly'>
                ใช่
              </label>
            </div>
          </div>

          {/* begin:: Type */}
          <div className='col-12 col-xl-8'>
            <label htmlFor='type' className='fs-6 mb-3 fw-bold'>
              ประเภทการติดตั้ง
              <span className='required' />
            </label>

            <div className='row g-5'>
              {MOCK_TYPE_OPTIONS.map((option, index) => (
                <div className='col-4' key={`${index}-installationForm`}>
                  <div className='form-check form-check-custom cursor-pointer'>
                    <input
                      className='form-check-input cursor-pointer'
                      type='checkbox'
                      checked={formik.values.installationCategory.find(c => c.key === option.value)}
                      onChange={(e: any) => {
                        onCheckInstallationCategory(option.value, e.currentTarget.checked)
                      }}
                      id={option.value}
                      name='installationCategory'
                      disabled={isView}
                    />
                    <label
                      className='form-check-label text-black cursor-pointer '
                      htmlFor={option.value}>
                      {option.label}
                    </label>

                    <input
                      className={clsx('form-control form-control-sm w-50 ms-5', {
                        'opacity-1': formik.values.installationCategory.find(
                          c => c.key === option.value
                        ),
                        'opacity-0': !formik.values.installationCategory.find(
                          c => c.key === option.value
                        ),
                      })}
                      placeholder='กรอกจำนวน'
                      value={
                        formik.values.installationCategory.find(c => c.key === option.value)
                          ?.quantity
                      }
                      onChange={(e: any) =>
                        onChangeInstallationCategory(option.value, e.currentTarget.value)
                      }
                      name='installationCategoryQuantity'
                      disabled={isView}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* <Select
              name={`installationCategory`}
              isSearchable={true}
              options={MOCK_TYPE_OPTIONS}
              styles={{
                control: (provided  :any) =>  ({
                  ...provided,
                  borderColor: '#e1e3ea',
                }),
              }}
              value={
                MOCK_TYPE_OPTIONS.find(
                  option => option.value === formik.values.installationCategory
                ) ?? null
              }
              onChange={(val :any) => formik.setFieldValue('installationCategory', val?.value)}
            /> */}
          </div>
          {/* end:: Type */}

          {/* begin:: Drop */}
          <div className='col-12 col-xl-4'>
            {(formik.values.installationCategory.find(i => i.key === 'PURE_DRIVE') ||
              formik.values.installationCategory.find(i => i.key === 'PREBORE_DRIVE')) && (
              <>
                <label htmlFor='drop' className='fs-6 mb-3'>
                  กรุณาเลือกตัวเลือกในการติดตั้ง
                  <span className='required' />
                </label>

                <Select
                  isSearchable={true}
                  isDisabled={isView}
                  options={MOCK_INSTALLATION_CATEGORY_CHILD__OPTIONS}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor:
                        formik.touched.installationCategoryOption && formik.errors.installationCategoryOption
                          ? '#dc3545'
                          : '#e1e3ea',
                    }),
                  }}
                  className={clsx({
                    'is-invalid':
                      formik.touched.installationCategoryOption && formik.errors.installationCategoryOption,
                  })}
                  value={MOCK_INSTALLATION_CATEGORY_CHILD__OPTIONS.find(
                    item => item.value === formik.values.installationCategoryOption
                  )}
                  onChange={(e: any) => formik.setFieldValue('installationCategoryOption', e?.value)}
                  name='installationCategoryOption'
                />
                {formik.touched.installationCategoryOption && formik.errors.installationCategoryOption && (
                  <div className='invalid-feedback'>{formik.errors.installationCategoryOption}</div>
                )}
              </>
            )}
          </div>
          {/* end:: Drop */}

          {/* begin:: Layout Planning  */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='installationPlanner'
              label='การวางผัง'
              options={[
                {
                  id: 'pacoLayoutPlanning',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'customerLayoutPlanning',
                  label: 'ลูกค้า',
                  value: 'CUSTOMER',
                },
              ]}
              checked={formik.values.installationPlanner}
              onChange={(val: any) => {
                formik.setFieldValue('installationPlanner', val)
              }}
            />
          </div>
          {/* end:: Layout Planning */}

          {/* begin:: Layout Planning  */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveGroundworkPlan'
              label='แบบแปลนฐานราก + เสาเข็ม'
              options={[
                {
                  id: 'hasFoundationAndPile',
                  label: 'มี',
                  value: 'มี',
                },
                {
                  id: 'dontHaveFoundationAndPile',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
                {
                  id: 'dontKnowFoundationAndPile',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                  inputPlaceholder: 'หมายเหตุ',
                  hasInput: formik.values.haveGroundworkPlan === 'อื่นๆ',
                  inputValue: formik.values.haveGroundworkPlanOther,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('haveGroundworkPlanOther', val)
                  },
                },
              ]}
              checked={formik.values.haveGroundworkPlan}
              onChange={(val: any) => {
                formik.setFieldValue('haveGroundworkPlan', val)
              }}
            />
          </div>
          {/* end:: Layout Planning */}

          {/* begin:: Layout  */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveLayoutPlan'
              label='แบบ LAY OUT'
              options={[
                {
                  id: 'haveLayout',
                  label: 'มี',
                  value: 'มี',
                },
                {
                  id: 'dontHaveLayout',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
                {
                  id: 'dontKnowLayout',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                  inputPlaceholder: 'หมายเหตุ',
                  hasInput: formik.values.haveLayoutPlan === 'อื่นๆ',
                  inputValue: formik.values.haveLayoutPlanOther,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('haveLayoutPlanOther', val)
                  },
                },
              ]}
              checked={formik.values.haveLayoutPlan}
              onChange={(val: any) => {
                formik.setFieldValue('haveLayoutPlan', val)
              }}
            />
          </div>
          {/* end:: Layout */}

          <div className='separator border-2' />

          {/* begin:: Crane */}
          <div className='col-12'>
            <div className='row gy-5'>
              <div className='col-12 col-xl-3 fw-bold'>ใช้ ปั้นจั่น: </div>
              <div className='col-12 col-xl-9'>
                <div className='form-check form-check-custom'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={formik.values.useDavit}
                    onChange={(e: any) => {
                      formik.setFieldValue('useDavit', e.currentTarget.checked)
                    }}
                    id='useDavit'
                    disabled={isView}
                  />
                  <label className='form-check-label text-black' htmlFor='useDavit'>
                    ใช้งาน
                  </label>
                </div>
              </div>

              {formik.values.useDavit === true && (
                <>
                  <div className='col-12 d-none d-lg-block col-xl-3' />

                  <div className='col-12 col-xl-3'>
                    ขนาด
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.davitSize}
                        onChange={(e: any) => {
                          formik.setFieldValue('davitSize', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (บูม)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    สูง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.davitHeightMeter}
                        onChange={(e: any) => {
                          formik.setFieldValue('davitHeightMeter', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    จำนวน
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.davitQuantity}
                        onChange={(e: any) => {
                          formik.setFieldValue('davitQuantity', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (ตัว)
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* end:: Crane */}

          <div className='separator border-2' />

          {/* begin:: PD */}
          <div className='col-12'>
            <div className='row gy-5'>
              <div className='col-12 col-xl-3 fw-bold'>ใช้ PD: </div>

              <div className='col-12 col-xl-9'>
                <div className='form-check form-check-custom'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={formik.values.usePD}
                    onChange={(e: any) => {
                      formik.setFieldValue('usePD', e.currentTarget.checked)
                    }}
                    id='usePD'
                    disabled={isView}
                  />
                  <label className='form-check-label text-black' htmlFor='usePD'>
                    ใช้งาน
                  </label>
                </div>
              </div>

              {formik.values.usePD === true && (
                <>
                  <div className='col-12 d-none d-lg-block col-xl-3' />

                  <div className='col-12 col-xl-3'>
                    ขนาด
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.pdSize}
                        onChange={(e: any) => {
                          formik.setFieldValue('pdSize', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (บูม)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    สูง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.pdHeightMeter}
                        onChange={(e: any) => {
                          formik.setFieldValue('pdHeightMeter', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    จำนวน
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.pdQuantity}
                        onChange={(e: any) => {
                          formik.setFieldValue('pdQuantity', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (ตัว)
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* end:: PD */}

          <div className='separator border-2' />

          {/* begin:: LIP */}
          <div className='col-12'>
            <div className='row gy-5'>
              <div className='col-12 col-xl-3 fw-bold'>ใช้ JIP: </div>

              <div className='col-12 col-xl-9'>
                <div className='form-check form-check-custom'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={formik.values.useLIP}
                    onChange={(e: any) => {
                      formik.setFieldValue('useLIP', e.currentTarget.checked)
                    }}
                    id='useLIP'
                    disabled={isView}
                  />
                  <label className='form-check-label text-black' htmlFor='useLIP'>
                    ใช้งาน
                  </label>
                </div>
              </div>

              {formik.values.useLIP === true && (
                <>
                  <div className='col-12 d-none d-lg-block col-xl-3' />

                  <div className='col-12 col-xl-3'>
                    ขนาด
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.lipSize}
                        onChange={(e: any) => {
                          formik.setFieldValue('lipSize', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (บูม)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    สูง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.lipHeightMeter}
                        onChange={(e: any) => {
                          formik.setFieldValue('lipHeightMeter', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    จำนวน
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`machine`}
                        value={formik.values.lipQuantity}
                        onChange={(e: any) => {
                          formik.setFieldValue('lipQuantity', e.currentTarget.value)
                        }}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (ตัว)
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* end:: LIP */}

          <div className='separator border-2' />

          {/* begin:: Pile Head */}
          <div className='col-12'>
            <RadioInput
              name='davitHeadSystem'
              label='ใช้หัวตอกระบบ'
              options={[
                {
                  id: 'hydraulic',
                  label: 'Hydraulic',
                  value: 'hydraulic',
                },
                {
                  id: 'drop',
                  label: 'Drop',
                  value: 'drop',
                },
              ]}
              checked={formik.values.davitHeadSystem}
              onChange={(val: any) => {
                formik.setFieldValue('davitHeadSystem', val)
              }}
            />

            <div className='row mt-4'>
              <div className='d-none d-xl-flex col-xl-3' />

              <div className='col-12 col-xl-4'>
                จำนวน
                <span className='align-items-center d-flex flex-row' style={{ gap: '12px' }}>
                  <div className='position-relative w-100'>
                    <input
                      name='davitHeadSize'
                      type='text'
                      className='form-control form-control-sm me-5'
                      value={formik.values.davitHeadSize}
                      onChange={(e: any) => {
                        formik.setFieldValue('davitHeadSize', e.currentTarget.value)
                      }}
                      disabled={isView}
                    />

                    <div
                      className='position-absolute text-gray-500'
                      style={{ top: '22%', right: 10 }}>
                      (ตัว)
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          {/* end:: Pile Head */}

          <div className='separator border-2' />

          {/* begin:: Installation Equipment */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='installationKits'
              label='ชุดอุปกรณ์ที่ใช้ประกอบการติดตั้ง'
              options={[
                {
                  id: 'motor',
                  label: 'ชุดมอเตอร์',
                  value: 'ชุดมอเตอร์',
                },
                {
                  id: 'pressMotor',
                  label: 'ชุดกด + มอเตอร์',
                  value: 'ชุดกด + มอเตอร์',
                },
                {
                  id: 'drill',
                  label: 'สว่าน',
                  value: 'สว่าน',
                },
              ]}
              checked={formik.values.installationKits}
              onChange={(val: any) => {
                formik.setFieldValue('installationKits', val)
              }}
            />

            <div className='row mt-4'>
              <div className='d-none d-xl-flex col-xl-3' />

              <div className='col-6 col-xl-2'>
                ขนาด
                <span className='align-items-center d-flex flex-row' style={{ gap: '12px' }}>
                  <div className='position-relative w-100'>
                    <input
                      type='text'
                      className='form-control form-control-sm me-5'
                      name={`installationKitSize`}
                      value={formik.values.installationKitSize}
                      onChange={(e: any) => {
                        formik.setFieldValue('installationKitSize', e.currentTarget.value)
                      }}
                      disabled={isView}
                    />
                    <div
                      className='position-absolute text-gray-500'
                      style={{ top: '22%', right: 10 }}>
                      (มม.)
                    </div>
                  </div>
                </span>
              </div>

              <div className='col-6 col-xl-2'>
                ยาว
                <span className='align-items-center d-flex flex-row' style={{ gap: '12px' }}>
                  <div className='position-relative w-100'>
                    <input
                      type='text'
                      className='form-control form-control-sm me-5'
                      name={`installationKitsLength`}
                      value={formik.values.installationKitsLength}
                      onChange={(e: any) => {
                        formik.setFieldValue('installationKitsLength', e.currentTarget.value)
                      }}
                      disabled={isView}
                    />
                    <div
                      className='position-absolute text-gray-500'
                      style={{ top: '22%', right: 10 }}>
                      (มม.)
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          {/* end:: Installation Equipment */}

          <div className='separator border-2' />

          {/* begin:: Maximum Height */}
          <div className='col-12'>
            <div className='row fs-6'>
              <div className='col-12 col-xl-3 fw-bold'>
                ลักษณะทางเข้าของรถเสาเข็มนั้นสามารถบรรทุกเสาเข็มความยาวสูงสุดได้:
              </div>

              <div className='col-12 col-xl-4'>
                <div className='position-relative w-100'>
                  <input
                    type='text'
                    className='form-control form-control-sm me-5'
                    name={`maxHeightEntranceMeter`}
                    value={formik.values.maxHeightEntranceMeter}
                    onChange={(e: any) => {
                      formik.setFieldValue('maxHeightEntranceMeter', e.currentTarget.value)
                    }}
                    disabled={isView}
                  />
                  <div
                    className='position-absolute text-gray-500'
                    style={{ top: '22%', right: 10 }}>
                    (เมตร)
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end:: Maximum Height */}

          <div className='separator border-2' />

          {/* begin:: Transportation */}
          <div className='col-12'>
            <div className='row'>
              <div className='col-12 col-xl-3'>
                <label htmlFor='transportationByVehicle' className='fs-6 mb-3 fw-bold'>
                  ขนส่งโดยรถ
                </label>
              </div>
              <div className='col-12 col-xl-3'>
                <Select
                  name={`transportationByVehicle`}
                  isSearchable={true}
                  isDisabled={isView}
                  options={MOCK_TRANSPORTATION_OPTIONS}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  value={
                    MOCK_TRANSPORTATION_OPTIONS.find(
                      option => option.value === formik.values.transportationByVehicle
                    ) ?? null
                  }
                  onChange={(val: any) => {
                    formik.setFieldValue('transportationByVehicle', val?.value)
                  }}
                />
              </div>
            </div>
          </div>
          {/* end:: Transportation */}

          {/* begin:: Transportation Time */}
          <div className='col-12'>
            <div className='row'>
              <div className='col-12 col-xl-3'>
                <label htmlFor='transportationAvailableTimeƒ' className='fs-6 fw-bold'>
                  ขนส่ง:
                </label>
              </div>
              <div className='col-12 col-xl-3'>
                <Select
                  name={`transportationAvailableTimeƒ`}
                  isSearchable={true}
                  isDisabled={isView}
                  options={MOCK_TRANSPORTATION_TIME_OPTIONS}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  value={
                    MOCK_TRANSPORTATION_TIME_OPTIONS.find(
                      option => option.value === formik.values.transportationAvailableTime
                    ) ?? null
                  }
                  onChange={(val: any) => {
                    formik.setFieldValue('transportationAvailableTime', val?.value)
                  }}
                />
              </div>
            </div>
          </div>
          {/* end:: Transportation Time */}

          <div className='separator border-2' />

          {/* begin:: Factory Distance */}
          <div className='col-12'>
            <div className='d-flex flex-row justify-content-between'>
              <div className='fw-bold'>
                หน่วยงานอยู่ห่างจากโรงงาน
                <span className='required' />
              </div>
            </div>
          </div>

          <div className='col-12'>
            <InstallationFactoryDistanceItem
              disabled={isView}
              idx={0}
              name='distanceFromFactoryKm'
              distance={formik.values.distanceFromFactoryKm}
              onChange={(key, value) =>
                onChangeFactoryDistance('distanceFromFactoryKm', key, value)
              }
            />
          </div>

          <div className='col-12'>
            <InstallationFactoryDistanceItem
              disabled={isView}
              idx={1}
              name='distanceFromFactoryKm2'
              distance={formik.values.distanceFromFactoryKm2}
              onChange={(key, value) =>
                onChangeFactoryDistance('distanceFromFactoryKm2', key, value)
              }
            />
          </div>

          <div className='col-12'>
            <InstallationFactoryDistanceItem
              disabled={isView}
              idx={2}
              name='distanceFromFactoryKm3'
              distance={formik.values.distanceFromFactoryKm3}
              onChange={(key, value) =>
                onChangeFactoryDistance('distanceFromFactoryKm3', key, value)
              }
            />
          </div>

          {/* <div className='col-12'>
            <div className='row fs-6'>
              <div className='col-12 col-xl-3'>หน่วยงานอยู่ห่างจากโรงงานประมาณ:</div>

              <div className='col-12 col-xl-4'>
                <div className='position-relative w-100'>
                  <input
                    type='text'
                    className='form-control form-control-sm me-5'
                    name={`distanceFromFactoryKm`}
                    value={formik.values.distanceFromFactoryKm}
                    onChange={(e:any) => {
                      formik.setFieldValue('distanceFromFactoryKm', e.currentTarget.value)
                    }}
                  />
                  <div
                    className='position-absolute text-gray-500'
                    style={{ top: '22%', right: 10 }}>
                    (กิโลเมตร)
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* end:: Factory Distance */}

          {/* begin:: Factory Options 2 KM */}
          {/* <div className='col-12'>
            <div className='row fs-6'>
              <div className='col-12 col-xl-3'>หน่วยงานอยู่ห่างจากโรงงานระยะ 2 กิโลเมตร</div>

              <div className='col-12 col-xl-4'>
                <Select
                  name={`distanceFromFactoryKm2`}
                  isSearchable={true}
                  isClearable
                  options={FACTORY_OPTIONS}
                  styles={{
                    control: (provided  :any) =>  ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  value={
                    FACTORY_OPTIONS.find(
                      option => option.value === formik.values.distanceFromFactoryKm2
                    ) ?? null
                  }
                  onChange={(val :any) => {
                    formik.setFieldValue('distanceFromFactoryKm2', val?.value)
                  }}
                />
              </div>
            </div>
          </div> */}
          {/* end:: Factory Options 2 KM */}

          {/* begin:: Factory Options 2 KM */}
          {/* <div className='col-12'>
            <div className='row fs-6'>
              <div className='col-12 col-xl-3'>หน่วยงานอยู่ห่างจากโรงงานระยะ 3 กิโลเมตร</div>

              <div className='col-12 col-xl-4'>
                <Select
                  name={`distanceFromFactoryKm3`}
                  isSearchable={true}
                  isClearable
                  options={FACTORY_OPTIONS}
                  styles={{
                    control: (provided  :any) =>  ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  value={
                    FACTORY_OPTIONS.find(
                      option => option.value === formik.values.distanceFromFactoryKm3
                    ) ?? null
                  }
                  onChange={(val :any) => {
                    formik.setFieldValue('distanceFromFactoryKm3', val?.value)
                  }}
                />
              </div>
            </div>
          </div> */}
          {/* end:: Factory Options 2 KM */}

          <div className='separator border-2' />

          {/* begin:: Crane */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='craneToPole'
              label='รถเครนลงเสา'
              options={[
                {
                  id: 'cranePaco',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'craneCustomer',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'craneOther',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                  inputPlaceholder: 'หมายเหตุ',
                  hasInput: formik.values.craneToPole === 'อื่นๆ',
                  inputValue: formik.values.craneToPoleOther,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('craneToPoleOther', val)
                  },
                },
              ]}
              checked={formik.values.craneToPole}
              onChange={(val: any) => {
                formik.setFieldValue('craneToPole', val)
              }}
            />
          </div>
          {/* end:: Crane */}

          {/* begin:: NeighboringBuilding Radio */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveBuildingInArea'
              label='อาคารข้างเคียง'
              options={[
                {
                  id: 'haveNeighboringBuilding',
                  label: 'มี',
                  value: 'มี',
                },
                {
                  id: 'noNeighboringBuilding',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
              ]}
              checked={formik.values.haveBuildingInArea}
              onChange={(val: any) => {
                formik.setFieldValue('haveBuildingInArea', val)
              }}
            />
          </div>
          {/* end:: NeighboringBuilding Radio */}

          {/* begin:: Side Effect of Neighbouring Building */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='buildingInAreaEffectCondition'
              label='สภาพอาคารข้างเคียง'
              options={[
                {
                  id: 'noSideEffect',
                  label: 'ไม่มีผลกระทบต่อการติดตั้งเสาเข็ม',
                  value: 'NO_SIDE_EFFECT',
                },
                {
                  id: 'hasSideEffect',
                  label: 'มีผลกระทบต่อการติดตั้งเสาเข็ม',
                  value: 'HAS_SIDE_EFFECT',
                },
              ]}
              checked={formik.values.buildingInAreaEffectCondition}
              onChange={(val: any) => {
                formik.setFieldValue('buildingInAreaEffectCondition', val)
              }}
            />
          </div>
          {/* end:: Side Effect of Neighbouring Building */}

          {/* begin:: East Detail NeighboringBuilding */}
          {formik.values.buildingInAreaEffectCondition === 'HAS_SIDE_EFFECT' && (
            <div className='col-12'>
              <div className='row gy-3'>
                <div className='col-12'>
                  <label htmlFor='direction.north' className='fs-6 mb-3 fw-bold'>
                    ทิศเหนือ
                  </label>

                  <div className='row gy-5'>
                    <div className='col-12 col-xl-3'>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='text-grey'>อัพโหลดรูปภาพ</div>
                        <button
                          type='button'
                          className='btn btn-sm btn-primary'
                          onClick={() => {
                            adjacentPictureNorthRef?.current?.click()
                          }}
                          disabled={isView}>
                          Upload File
                        </button>
                      </div>

                      <input
                        ref={adjacentPictureNorthRef}
                        name='adjacentPictureNorth-file-input'
                        type='file'
                        className='d-none'
                        onChange={(e: any) => {
                          const result = checkingFileAllowedTypesAdjacentPicture(
                            e.target.files?.[0]
                          )
                          if (result === false) return
                          // @ts-ignore
                          formik.setFieldValue('adjacentPictureNorth', e.target.files[0])
                        }}
                        // accept='.jpg, .png, .jpeg'
                      />
                      {formik.values.adjacentPictureNorth ? (
                        <div className='position-relative mt-7'>
                          <img
                            src={
                              typeof formik.values.adjacentPictureNorth !== 'string'
                                ? URL.createObjectURL(formik.values.adjacentPictureNorth as any)
                                : formik.values.adjacentPictureNorth
                            }
                            onError={(e: any) => {
                              e.target.onerror = null
                              e.target.src = '/media/icons/default-placeholder.png'
                            }}
                            alt='Adjacent North'
                            className='w-100 object-fit-cover h-200px rounded'
                          />
                          <div
                            className='btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute'
                            style={{ top: -10, right: -10 }}
                            onClick={() => formik.setFieldValue('adjacentPictureNorth', null)}>
                            <KTSVG
                              className='svg-icon-1'
                              path='/media/icons/duotune/general/gen027.svg'
                            />
                          </div>
                        </div>
                      ) : (
                        <div className='text-gray text-center d-flex align-items-center justify-content-center h-100'>
                          <span>No file uploaded</span>
                        </div>
                      )}
                    </div>

                    <div className='col-12 col-xl-9'>
                      <div className='row gy-5'>
                        <div className='col-12'>
                          <div>ประเภท / ลักษณะ</div>
                          <input
                            name='buildingInArea.north.characteristics'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.north?.characteristics}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.north.characteristics',
                                e.currentTarget.value
                              )
                            }}
                            disabled={isView}
                          />
                        </div>
                        <div className='col-12'>
                          <div>จำนวน</div>
                          <input
                            name='buildingInArea.north.quantity'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.north?.quantity}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.north.quantity',
                                e.currentTarget.value
                              )
                            }}
                            disabled={isView}
                          />
                        </div>
                        <div className='col-12'>
                          <div>สภาพ</div>
                          <input
                            name='buildingInArea.north.condition'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.north?.condition}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.north.condition',
                                e.currentTarget.value
                              )
                            }}
                            disabled={isView}
                          />
                        </div>
                        <div className='col-12'>
                          <div>ระยะห่างจากผนัง (เมตร)</div>
                          <input
                            name='buildingInArea.north.distance'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.north?.distance}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.north.distance',
                                e.currentTarget.value
                              )
                            }}
                            disabled={isView}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-12'>
                  <label htmlFor='direction.north' className='fs-6 mb-3 fw-bold'>
                    ทิศใต้
                  </label>

                  <div className='row gy-5'>
                    <div className='col-12 col-xl-3'>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='text-grey'>อัพโหลดรูปภาพ</div>
                        <button
                          type='button'
                          className='btn btn-sm btn-primary'
                          onClick={() => {
                            adjacentPictureSouthRef?.current?.click()
                          }}>
                          Upload File
                        </button>
                      </div>

                      <input
                        ref={adjacentPictureSouthRef}
                        name='adjacentPictureSouth'
                        type='file'
                        className='d-none'
                        onChange={(e: any) => {
                          const result = checkingFileAllowedTypesAdjacentPicture(
                            e.target.files?.[0]
                          )
                          if (result === false) return
                          // @ts-ignore
                          formik.setFieldValue('adjacentPictureSouth', e.target.files[0])
                        }}
                        disabled={isView}
                        // accept='.jpg, .png, .jpeg'
                      />
                      {formik.values.adjacentPictureSouth ? (
                        <div className='position-relative mt-7'>
                          <img
                            src={
                              typeof formik.values.adjacentPictureSouth !== 'string'
                                ? URL.createObjectURL(formik.values.adjacentPictureSouth as any)
                                : formik.values.adjacentPictureSouth
                            }
                            onError={(e: any) => {
                              e.target.onerror = null
                              e.target.src = '/media/icons/default-placeholder.png'
                            }}
                            alt='Adjacent North'
                            className='w-100 object-fit-cover h-200px rounded'
                          />
                          <div
                            className='btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute'
                            style={{ top: -10, right: -10 }}
                            onClick={() => formik.setFieldValue('adjacentPictureSouth', null)}>
                            <KTSVG
                              className='svg-icon-1'
                              path='/media/icons/duotune/general/gen027.svg'
                            />
                          </div>
                        </div>
                      ) : (
                        <div className='text-gray text-center d-flex align-items-center justify-content-center h-100'>
                          <span>No file uploaded</span>
                        </div>
                      )}
                    </div>

                    <div className='col-12 col-xl-9'>
                      <div className='row gy-5'>
                        <div className='col-12'>
                          <div>ประเภท / ลักษณะ</div>
                          <input
                            name='buildingInArea.south.characteristics'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.south?.characteristics}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.south.characteristics',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>จำนวน</div>
                          <input
                            name='buildingInArea.south.quantity'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.south?.quantity}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.south.quantity',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>สภาพ</div>
                          <input
                            name='buildingInArea.south.condition'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.south?.condition}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.south.condition',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>ระยะห่างจากผนัง (เมตร)</div>
                          <input
                            name='buildingInArea.south.distance'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.south?.distance}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.south.distance',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-12'>
                  <label htmlFor='direction.north' className='fs-6 mb-3 fw-bold'>
                    ทิศตะวันออก
                  </label>

                  <div className='row gy-5'>
                    <div className='col-12 col-xl-3'>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='text-grey'>อัพโหลดรูปภาพ</div>
                        <button
                          type='button'
                          className='btn btn-sm btn-primary'
                          onClick={() => {
                            adjacentPictureEastRef?.current?.click()
                          }}>
                          Upload File
                        </button>
                      </div>

                      <input
                        ref={adjacentPictureEastRef}
                        name='adjacentPictureEast'
                        type='file'
                        className='d-none'
                        onChange={(e: any) => {
                          const result = checkingFileAllowedTypesAdjacentPicture(
                            e.target.files?.[0]
                          )
                          if (result === false) return
                          // @ts-ignore
                          formik.setFieldValue('adjacentPictureEast', e.target.files[0])
                        }}
                        // accept='.jpg, .png, .jpeg'
                      />
                      {formik.values.adjacentPictureEast ? (
                        <div className='position-relative mt-7'>
                          <img
                            src={
                              typeof formik.values.adjacentPictureEast !== 'string'
                                ? URL.createObjectURL(formik.values.adjacentPictureEast as any)
                                : formik.values.adjacentPictureEast
                            }
                            onError={(e: any) => {
                              e.target.onerror = null
                              e.target.src = '/media/icons/default-placeholder.png'
                            }}
                            alt='Adjacent North'
                            className='w-100 object-fit-cover h-200px rounded'
                          />
                          <div
                            className='btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute'
                            style={{ top: -10, right: -10 }}
                            onClick={() => formik.setFieldValue('adjacentPictureEast', null)}>
                            <KTSVG
                              className='svg-icon-1'
                              path='/media/icons/duotune/general/gen027.svg'
                            />
                          </div>
                        </div>
                      ) : (
                        <div className='text-gray text-center d-flex align-items-center justify-content-center h-100'>
                          <span>No file uploaded</span>
                        </div>
                      )}
                    </div>

                    <div className='col-12 col-xl-9'>
                      <div className='row gy-5'>
                        <div className='col-12'>
                          <div>ประเภท / ลักษณะ</div>
                          <input
                            name='buildingInArea.east.characteristics'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.east?.characteristics}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.east.characteristics',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>จำนวน</div>
                          <input
                            name='buildingInArea.east.quantity'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.east?.quantity}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.east.quantity',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>สภาพ</div>
                          <input
                            name='buildingInArea.east.condition'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.east?.condition}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.east.condition',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>ระยะห่างจากผนัง (เมตร)</div>
                          <input
                            name='buildingInArea.east.distance'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.east?.distance}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.east.distance',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-12'>
                  <label htmlFor='direction.north' className='fs-6 mb-3 fw-bold'>
                    ทิศตะวันตก
                  </label>

                  <div className='row gy-5'>
                    <div className='col-12 col-xl-3'>
                      <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div className='text-grey'>อัพโหลดรูปภาพ</div>
                        <button
                          type='button'
                          className='btn btn-sm btn-primary'
                          onClick={() => {
                            adjacentPictureWestRef?.current?.click()
                          }}>
                          Upload File
                        </button>
                      </div>

                      <input
                        ref={adjacentPictureWestRef}
                        name='adjacentPictureWest'
                        type='file'
                        className='d-none'
                        onChange={(e: any) => {
                          const result = checkingFileAllowedTypesAdjacentPicture(
                            e.target.files?.[0]
                          )
                          if (result === false) return
                          // @ts-ignore
                          formik.setFieldValue('adjacentPictureWest', e.target.files[0])
                        }}
                        // accept='.jpg, .png, .jpeg'
                      />
                      {formik.values.adjacentPictureWest ? (
                        <div className='position-relative mt-7'>
                          <img
                            src={
                              typeof formik.values.adjacentPictureWest !== 'string'
                                ? URL.createObjectURL(formik.values.adjacentPictureWest as any)
                                : formik.values.adjacentPictureWest
                            }
                            onError={(e: any) => {
                              e.target.onerror = null
                              e.target.src = '/media/icons/default-placeholder.png'
                            }}
                            alt='Adjacent North'
                            className='w-100 object-fit-cover h-200px rounded'
                          />
                          <div
                            className='btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute'
                            style={{ top: -10, right: -10 }}
                            onClick={() => formik.setFieldValue('adjacentPictureWest', null)}>
                            <KTSVG
                              className='svg-icon-1'
                              path='/media/icons/duotune/general/gen027.svg'
                            />
                          </div>
                        </div>
                      ) : (
                        <div className='text-gray text-center d-flex align-items-center justify-content-center h-100'>
                          <span>No file uploaded</span>
                        </div>
                      )}
                    </div>

                    <div className='col-12 col-xl-9'>
                      <div className='row gy-5'>
                        <div className='col-12'>
                          <div>ประเภท / ลักษณะ</div>
                          <input
                            name='buildingInArea.west.characteristics'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.west?.characteristics}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.west.characteristics',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>จำนวน</div>
                          <input
                            name='buildingInArea.west.quantity'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.west?.quantity}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.west.quantity',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>สภาพ</div>
                          <input
                            name='buildingInArea.west.condition'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.west?.condition}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.west.condition',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                        <div className='col-12'>
                          <div>ระยะห่างจากผนัง (เมตร)</div>
                          <input
                            name='buildingInArea.west.distance'
                            className='form-control form-control-sm'
                            value={formik.values.buildingInArea?.west?.distance}
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                'buildingInArea.west.distance',
                                e.currentTarget.value
                              )
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* begin:: East Detail NeighboringBuilding */}

          {/* begin:: Responsible Person for Neighbouring Building */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='buildingInAreaResponsibility'
              label='ความรับผิดชอบต่ออาคารข้างเคียง'
              options={[
                {
                  id: 'pacoResponsible',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'customerResponsible',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
              ]}
              checked={formik.values.buildingInAreaResponsibility}
              onChange={(val: any) => {
                formik.setFieldValue('buildingInAreaResponsibility', val)
              }}
            />
          </div>
          {/* end:: Responsible Person for Neighbouring Building */}

          {/* Risk of Drilling and Plan to Resolve Drilling */}
          {/* <div className='col-12'>
            <label htmlFor='riskOfDrilling' className='fs-6 mb-3 fw-bold'>
              ความเสี่ยงในการตอก
            </label>

            <Select
              name={`riskOfDrilling`}
              isSearchable={true}
              options={RISK_OF_DRILLING_OPTIONS}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  borderColor: '#e1e3ea',
                }),
              }}
              value={
                RISK_OF_DRILLING_OPTIONS.find(
                  option => option.value === formik.values.riskOfDrilling
                ) ?? null
              }
              onChange={(val: any) => {
                formik.setFieldValue('riskOfDrilling', val?.value)
              }}
              className='w-50'
            />
          </div> */}

          <div className='col-12'>
            <label htmlFor='riskOfDrillingPlan' className='fs-6 mb-3 fw-bold'>
              แผนแก้ไขความเสี่ยงในการตอก
            </label>

            <textarea
              disabled={isView}
              name='riskOfDrillingPlan'
              className='form-control form-control-sm'
              rows={10}
              value={formik.values.riskOfDrillingPlan}
              onChange={(e: any) => {
                formik.setFieldValue('riskOfDrillingPlan', e.currentTarget.value)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Installation
